(function () {
  "use strict";

  var APPLIED_FLAG = "__loxaComfybedssApplied";
  var ATOMIC_HEADER = "X-Loxa-Comfybedss-Atomic";

  function logoUrl() {
    var script = document.querySelector('script[src*="loxa-comfybedss"]');
    return (script && script.getAttribute("data-loxa-logo")) || "";
  }

  function logoMarkup() {
    return '<img src="' + logoUrl() + '" alt="" width="26" height="30">';
  }

  // Logging defers to core so the app embed's debugMode governs it.
  function log(message, obj) {
    var L = window.LoxaShopify;
    if (L && typeof L.log === "function") L.log("[comfybedss] " + message, obj);
  }

  // Errors always surface, whatever debugMode is set to — several of these report
  // embed misconfiguration, which is looked for precisely when debug is on. Core's
  // error() suppresses itself while debugMode is true, so warn directly.
  function notify(message, err, meta) {
    try {
      console.warn("[Loxa comfybedss] " + message, err || "", meta || "");
    } catch (e) {}
    try {
      if (window.Bugsnag && typeof window.Bugsnag.notify === "function") {
        window.Bugsnag.notify(err instanceof Error ? err : new Error(message), function (event) {
          event.addMetadata("loxa", { integration: "comfybedss", message: message, meta: meta || {} });
        });
      }
    } catch (e) {}
  }

  function shopRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return r.replace(/\/$/, "");
  }
  function money(pounds) { return "£" + Number(pounds).toFixed(2); }
  function premiumOf(plan) {
    return typeof plan.insurance_price === "number"
      ? plan.insurance_price : parseFloat(plan.insurance_price || "0");
  }
  function termOf(plan) { return String(plan.insurance_term || plan.term || ""); }

  function cleanTitle(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  // Titles come from Shopify's product JSON, never the rendered page.
  // Every product on the page, keyed by variant id, so an extra resolves to its own
  // title rather than the page's main product. Built from the product JSON of the
  // PDP and of each upsell, which are separate products.
  var titleByVariant = {};
  function loadTitles(handles) {
    var wanted = handles.filter(function (h) { return h && !productCache[h]; });
    wanted.forEach(function (h) {
      productCache[h] = fetch(shopRoot() + "/products/" + h + ".js",
        { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { indexProduct(p); return p; })
        .catch(function () { return null; });
    });
    return Promise.all(handles.map(function (h) {
      return h ? productCache[h] : null;
    }));
  }
  var productCache = {};

  // "Product - Variant", matching Liquid's item.title.
  function indexProduct(product) {
    if (!product) return;
    (product.variants || []).forEach(function (v) {
      var name = v.public_title || v.title;
      titleByVariant[String(v.id)] = cleanTitle(name && name !== "Default Title"
        ? product.title + " - " + name
        : product.title);
    });
  }

  function currentHandle() {
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    return m ? m[1] : null;
  }

  // The upsell holders carry only a variant id, so take each extra's handle from the
  // link the theme renders alongside it.
  function extraHandles() {
    var out = [];
    [".selected-mattress-upsell", ".selected-headboard-upsell"].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.classList.contains("hidden")) return;
      var link = el.querySelector('a[href*="/products/"]') ||
        (el.closest("*") && el.parentElement &&
          el.parentElement.querySelector('a[href*="/products/"]'));
      var href = link && link.getAttribute("href");
      var m = href && /\/products\/([^/?#]+)/.exec(href);
      if (m) out.push(m[1]);
    });
    return out;
  }

  // ── PDP ────────────────────────────────────────────────────────────────────
  // The mattress/headboard upsells selected on the page. Variant options are
  // already priced into the product's own variant and are not added again.
  function selectedExtras() {
    var out = [];
    [
      [".selected-mattress-upsell", ".selected-mattress"],
      [".selected-headboard-upsell", ".selected-headboard"]
    ].forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (!el || el.classList.contains("hidden")) return;
      var vid = el.getAttribute("data-variant-id");
      if (!vid) return;
      var titleEl = document.querySelector(pair[1]);
      var pence = parseInt(el.getAttribute("data-price"), 10);
      out.push({
        variantId: String(vid),
        quantity: parseInt(el.getAttribute("data-variant-quantity") || "1", 10) || 1,
        pricePounds: isFinite(pence) && pence > 0 ? pence / 100 : null,
        title: titleEl ? cleanTitle(titleEl.textContent) : ""
      });
    });
    return out;
  }

  // The PDP product itself. Requires the embed setting variantIdSource: "form" —
  // this theme does not refresh ShopifyAnalytics on a variant change.
  function mainLine(Loxa) {
    var ctx = typeof Loxa.getProductContext === "function" ? Loxa.getProductContext() : null;
    if (!ctx || !ctx.variantId) return null;
    var form = document.querySelector('form[action*="/cart/add"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    // Null, not 0, when the app has not resolved a price yet — quoteFor rejects on it.
    var price = Number(ctx.variantPrice);
    return {
      variantId: String(ctx.variantId),
      quantity: parseInt((qtyInput && qtyInput.value) || "1", 10) || 1,
      pricePounds: isFinite(price) && price > 0 ? price : null,
      title: cleanTitle(ctx.productTitle)
    };
  }

  function selectedVariantId() {
    var L = window.LoxaShopify;
    var ctx = L && typeof L.getProductContext === "function" ? L.getProductContext() : null;
    return ctx && ctx.variantId ? String(ctx.variantId) : null;
  }

  // Product plus extras, with same-variant lines folded together — Shopify merges
  // those into one cart line, so they must carry one cover between them.
  function insurableLines(Loxa) {
    var main = mainLine(Loxa);
    if (!main) return [];
    var byVariant = {};
    var order = [];
    [main].concat(selectedExtras()).forEach(function (line) {
      var existing = byVariant[line.variantId];
      if (existing) {
        existing.quantity += line.quantity;
        return;
      }
      byVariant[line.variantId] = line;
      order.push(line);
    });
    return order;
  }

  // Replace each line's title with Shopify's own, keyed by that line's variant id.
  // The main product and each extra are different products, so all their handles are
  // loaded — using only the PDP's product gave every line the same title.
  function withShopifyTitles(lines) {
    return loadTitles([currentHandle()].concat(extraHandles())).then(function () {
      var missing = lines.some(function (line) {
        return !titleByVariant[String(line.variantId)];
      });
      // An extra whose handle is not on the page still resolves once it is in the
      // cart, where Shopify gives the line its real title.
      return missing ? indexFromCart() : null;
    }).then(function () {
      lines.forEach(function (line) {
        var t = titleByVariant[String(line.variantId)];
        if (t) line.title = t;
      });
      return lines;
    }).catch(function () { return lines; });
  }

  function indexFromCart() {
    return readCart().then(function (cart) {
      (cart.items || []).forEach(function (it) {
        if (isCoverLine(it)) return;
        titleByVariant[String(it.variant_id)] = cleanTitle(it.title);
      });
    }).catch(function () {});
  }

  // ── Quote ──────────────────────────────────────────────────────────────────
  // Priced per line straight from the app proxy, memoised by variant and price.
  // Core's fetchInsurancePrice only answers for the current product context, so it
  // cannot quote the extras on the same page.
  var quoteCache = {};
  function quoteFor(Loxa, line) {
    // Never quote without a real price. A missing or unresolved price used to fall
    // through as 0, and the engine answers that with its lowest band — a genuine
    // premium against a value the product does not have. Reject instead, so the row
    // stays pending and can retry once the price is known.
    var price = Number(line && line.pricePounds);
    if (!line || !line.variantId || !isFinite(price) || price <= 0) {
      notify("refusing to quote without a price", null,
        { variantId: line && line.variantId, pricePounds: line && line.pricePounds });
      return Promise.reject(new Error("no price for quote"));
    }

    var key = line.variantId + ":" + Number(line.pricePounds).toFixed(2);
    if (quoteCache[key]) return quoteCache[key];

    var url = shopRoot() + "/apps/proxy/multi_ai_price" +
      "?product_sku=" + encodeURIComponent(line.variantId) +
      "&product_title=" + encodeURIComponent(line.title || "") +
      "&product_price=" + encodeURIComponent(Number(line.pricePounds).toFixed(2));

    quoteCache[key] = fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) {
        // Throw on failure so it stays distinct from an uninsurable product:
        // uninsurable resolves to null and hides the row, a failure allows a retry.
        if (!r.ok) throw new Error("quote HTTP " + r.status);
        return r.json();
      })
      .then(function (res) {
        if (!res || !res.insurable || !res.insurances || !res.insurances.length) return null;
        return {
          insurances: res.insurances,
          category: res.insurance_category || "",
          productTitle: line.title,
          pricePounds: line.pricePounds
        };
      }).catch(function (e) {
        notify("quote failed", e, { variantId: line.variantId, title: line.title });
        delete quoteCache[key];
        throw e;
      });
    return quoteCache[key];
  }

  // The plan the pricing engine flags as default_selected.
  function defaultPlan(quote) {
    if (!quote || !quote.insurances || !quote.insurances.length) return null;
    var list = quote.insurances, primary = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].default_selected) { primary = list[i]; break; }
    }
    if (!primary) primary = list[0];
    return premiumOf(primary) > 0 ? primary : null;
  }

  // ── PDP badge ──────────────────────────────────────────────────────────────
  // One badge covering the product plus any selected extras. Its price is the sum
  // of each line's own premium, and at add-to-cart it becomes one cover per line.
  var badge = { plans: null, total: 0, term: "", checked: false };

  function badgeAnchor() { return document.querySelector("[data-loxa-protection]"); }

  function extrasRoot() { return document.querySelector("[data-optional-extras]"); }

  function extrasHasThemeCards() {
    var root = extrasRoot();
    if (!root) return false;
    return !!root.querySelector("[data-optional-extra-card]");
  }

  function syncOptionalExtrasVisibility(loxaVisible) {
    var anchor = badgeAnchor();
    var root = extrasRoot();

    if (anchor) {
      if (loxaVisible) {
        anchor.removeAttribute("hidden");
        anchor.style.display = "";
      } else {
        anchor.style.display = "none";
      }
    }

    if (!root) return;

    if (extrasHasThemeCards() || loxaVisible) {
      root.removeAttribute("hidden");
      root.style.display = "";
    } else {
      root.setAttribute("hidden", "");
    }
  }

  function ensureBadgeShell(anchor) {
    if (anchor.querySelector("[data-loxa-card]")) return;
    anchor.innerHTML =
      '<div class="optional-extra-card loxa-cb-card" data-loxa-card>' +
        '<div class="optional-extra-card__top loxa-cb-row">' +
          '<span class="optional-extra-card__icon loxa-cb-icon" aria-hidden="true">' +
            logoMarkup() +
          '</span>' +
          '<div class="optional-extra-card__title-row">' +
            '<span class="optional-extra-card__title loxa-cb-label" data-loxa-badge-label></span>' +
            '<span class="optional-extra-card__price loxa-cb-price" data-loxa-badge-price></span>' +
            '<input type="checkbox" class="optional-extra-card__checkbox loxa-cb-checkbox" ' +
              'data-loxa-badge-checkbox aria-label="Add protection">' +
          '</div>' +
        '</div>' +
        '<p class="optional-extra-card__description loxa-cb-desc">' +
          'Protect your furniture against accidental stains, ' +
          'accidental damage and structural faults. ' +
          '<button type="button" class="optional-extra-card__details loxa-cb-details" ' +
            'data-loxa-badge-details>See Details</button></p>' +
      '</div>';

    anchor.querySelector("[data-loxa-badge-checkbox]").addEventListener("change", function (e) {
      setBadgeChecked(!!e.target.checked);
    });
    anchor.querySelector("[data-loxa-badge-details]").addEventListener("click", function () {
      openSidebar();
    });
  }

  // The checkbox drives core's selection state, which the add-to-cart reads.
  function setBadgeChecked(checked) {
    badge.checked = checked;
    var L = window.LoxaShopify;
    if (!L) return;
    if (checked && badge.plans && badge.plans.length) {
      L.selectedInsuranceCode = badge.plans[0].plan.code;
    } else {
      L.selectedInsuranceCode = "__none";
    }
    var box = document.querySelector("[data-loxa-badge-checkbox]");
    if (box) box.checked = checked;
    log("badge", checked ? "selected " + L.selectedInsuranceCode : "deselected");
  }

  function renderBadge(Loxa) {
    var anchor = badgeAnchor();
    if (!anchor) return;
    var lines = insurableLines(Loxa);
    if (!lines.length) {
      syncOptionalExtrasVisibility(false);
      return;
    }

    ensureBadgeShell(anchor);
    var card = anchor.querySelector("[data-loxa-card]");
    card.setAttribute("data-loxa-busy", "1");

    withShopifyTitles(lines).then(function (titled) {
      return Promise.all(titled.map(function (line) {
        if (!line.pricePounds) return Promise.resolve(null);
        return quoteFor(Loxa, line).then(function (quote) {
          var plan = defaultPlan(quote);
          return plan ? { line: line, quote: quote, plan: plan } : null;
        }).catch(function () { return null; });
      }));
    }).then(function (results) {
      var ok = results.filter(Boolean);
      card.removeAttribute("data-loxa-busy");
      if (!ok.length) {
        badge.plans = null;
        setBadgeChecked(false);
        syncOptionalExtrasVisibility(false);
        return;
      }
      var total = ok.reduce(function (s, r) {
        return s + premiumOf(r.plan) * (r.line.quantity || 1);
      }, 0);
      badge.plans = ok;
      badge.total = total;
      badge.term = termOf(ok[0].plan);

      anchor.querySelector("[data-loxa-badge-label]").textContent =
        "Add " + badge.term + " Year Accidental Damage & Stains Protection";
      anchor.querySelector("[data-loxa-badge-price]").textContent = money(total);
      syncOptionalExtrasVisibility(true);
      if (badge.checked) setBadgeChecked(true);
      syncLastInsuranceData(Loxa);
      log("badge", { lines: ok.length, total: total, term: badge.term });
    });
  }

  // A quote whose per-term prices are the summed premiums across every badge line,
  // so the sidebar shows the same total as the badge at any term.
  function summedQuote() {
    if (!badge.plans || !badge.plans.length) return null;
    var base = badge.plans[0].quote;
    var byTerm = {};

    badge.plans.forEach(function (entry) {
      var qty = entry.line.quantity || 1;
      entry.quote.insurances.forEach(function (plan) {
        var term = termOf(plan);
        var premium = premiumOf(plan);
        if (!term || !(premium > 0)) return;
        if (!byTerm[term]) byTerm[term] = { template: plan, total: 0, lines: 0 };
        byTerm[term].total += premium * qty;
        byTerm[term].lines++;
      });
    });

    // Only offer a term every line can actually be covered for.
    var expected = badge.plans.length;
    var insurances = [];
    Object.keys(byTerm).forEach(function (term) {
      var e = byTerm[term];
      if (e.lines !== expected) return;
      var merged = {};
      for (var k in e.template) {
        if (e.template.hasOwnProperty(k)) merged[k] = e.template[k];
      }
      merged.insurance_price = Math.round(e.total * 100) / 100;
      insurances.push(merged);
    });
    if (!insurances.length) return null;

    insurances.sort(function (a, b) { return premiumOf(b) - premiumOf(a); });

    var out = {};
    for (var k2 in base) { if (base.hasOwnProperty(k2)) out[k2] = base[k2]; }
    out.insurances = insurances;
    return out;
  }

  function openSidebar() {
    var L = window.LoxaShopify;
    if (!L || typeof L.openSidebar !== "function") return;
    var data = summedQuote() || L.lastInsuranceData;
    if (!data) { notify("no quote data for sidebar"); return; }
    try {
      L.openSidebar(data);
      watchSidebarPromotion();
    } catch (e) { notify("openSidebar failed", e); }
  }

  // Second chance opens off lastInsuranceData, so keep that carrying the summed
  // premiums too and every surface core opens agrees with the badge.
  function syncLastInsuranceData(Loxa) {
    var summed = summedQuote();
    if (!summed) return;
    var current = Loxa.lastInsuranceData;
    // Nothing to do when the basket is just the PDP product on its own.
    if (badge.plans && badge.plans.length < 2) return;
    if (current && current.__loxaSummedFor === summed.insurances.map(function (p) {
      return p.code + ":" + premiumOf(p);
    }).join("|")) return;

    summed.__loxaSummedFor = summed.insurances.map(function (p) {
      return p.code + ":" + premiumOf(p);
    }).join("|");
    Loxa.lastInsuranceData = summed;
    log("lastInsuranceData now covers lines", badge.plans.length);
  }

  // Is the mini-cart drawer open as a native popover? Tested specifically rather
  // than "any open popover" — the theme's upsell popup is one too, and promoting
  // over that would put the sidebar in the top layer on a PDP.
  function drawerIsOpen() {
    // The theme carries mini-cart-wrapper as both an id and a class.
    var els = document.querySelectorAll("#mini-cart-wrapper, .mini-cart-wrapper");
    for (var i = 0; i < els.length; i++) {
      if (!els[i].hasAttribute("popover")) continue;
      try { if (els[i].matches(":popover-open")) return true; } catch (e) {}
    }
    return false;
  }

  // Raise the sidebar into the top layer so it paints above the drawer, which is a
  // native popover and cannot be beaten with z-index. "manual" so it is not light
  // dismissed by Esc or an outside click.
  function promoteSidebarToTopLayer() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (!panel || typeof panel.showPopover !== "function") return;
    if (!drawerIsOpen()) return;
    // Re-setting the attribute on a showing popover drops it out of the top layer.
    try {
      if (panel.matches(":popover-open")) return;
      // Scrim FIRST: the top layer paints in insertion order, not by z-index, so
      // whatever is promoted last sits on top. The panel must be last.
      promoteOverlayToTopLayer();
      panel.setAttribute("popover", "manual");
      panel.showPopover();
    } catch (e) { /* not supported — falls back to z-index */ }
  }

  // The scrim joins the sidebar in the top layer, otherwise it paints beneath the
  // drawer and the drawer stays undimmed and clickable behind the sidebar.
  function promoteOverlayToTopLayer() {
    var el = document.getElementById("loxa-shopify-sidebar-overlay");
    if (!el) {
      notify("core's sidebar overlay is missing — the drawer will not be dimmed");
      return;
    }
    if (typeof el.showPopover !== "function") return;
    try {
      if (el.matches(":popover-open")) return;
      el.setAttribute("popover", "manual");
      el.showPopover();
    } catch (e) {}
  }

  // Close the sidebar only. Never synthesise a click on core's ✕ — that propagates
  // as a light dismiss and closes the drawer behind it too.
  function closeOurSidebar() {
    // Demote before closing so the panel leaves the top layer while it is still
    // ours to control. Core's closeSidebar hides the scrim via its own class.
    demoteSidebarFromTopLayer();
    var L = window.LoxaShopify;
    if (L && typeof L.closeSidebar === "function") {
      try { L.closeSidebar(); return; } catch (e) {}
    }
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (panel) panel.classList.remove("loxa-sidebar-open");
  }

  var POLICY_DOCUMENT_URLS = {
    ipid: "https://cdn.shopify.com/s/files/1/0642/8151/0127/files/Loxa_Product_Protection_AD_EW_IPID_2026_V1.pdf?v=1790920408",
    wording: "https://cdn.shopify.com/s/files/1/0642/8151/0127/files/Loxa_Product_Protection_AD_EW_Policy_Wording_2026_V1.pdf?v=1790920414"
  };

  // Core links these to loxacover.com. Point them at the store's 2026 PDFs
  // whenever the sidebar content is rendered.
  function updatePolicyLinks() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (!panel) return;

    [].forEach.call(panel.querySelectorAll("a"), function (link) {
      var label = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var href = link.getAttribute("href") || "";
      var next = null;

      if (label === "ipid" || /ipid/i.test(href)) next = POLICY_DOCUMENT_URLS.ipid;
      else if (label === "policy wording" || /policy-latest|policy_wording/i.test(href)) {
        next = POLICY_DOCUMENT_URLS.wording;
      }
      if (!next) return;

      link.classList.add("loxa-policy-link");
      if (link.getAttribute("href") === next) return;

      link.setAttribute("href", next);
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }

  // Title and "Powered by Loxa" go in the header bar; the subheading stays in the
  // body above the options. Core renders all three into the content body.
  function moveIntroIntoHeader() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (!panel) return;
    var header = panel.querySelector(".loxa-sidebar-header");
    var intro = panel.querySelector(".loxa-sidebar-intro");
    if (!header || !intro) return;

    var body = panel.querySelector(".loxa-sidebar-content-root");
    var sub = intro.querySelector(".loxa-sidebar-subheading");
    if (sub && body) body.insertBefore(sub, body.firstChild);

    if (intro.parentElement === header) return;
    var close = header.querySelector(".loxa-sidebar-close");
    if (close) header.insertBefore(intro, close);
    else header.appendChild(intro);
  }

  // Removing the attribute leaves the top layer without triggering dismiss handling.
  function demoteSidebarFromTopLayer() {
    [
      document.getElementById("loxa-shopify-sidebar"),
      document.getElementById("loxa-shopify-sidebar-overlay")
    ].forEach(function (el) {
      if (!el) return;
      try { el.removeAttribute("popover"); } catch (e) {}
    });
  }

  // Deferred so the click that closed the sidebar cannot dismiss the drawer.
  function restoreDrawerLightDismissAfterClick() {
    setTimeout(function () { setDrawerLightDismiss(true); }, 0);
  }

  // The drawer is an "auto" popover, so a click in our sidebar counts as outside it and
  // the browser dismisses it. Make it "manual" while our sidebar is open. The mode
  // cannot change on an open popover, hence close-set-reopen.
  function setDrawerLightDismiss(enabled) {
    [].forEach.call(document.querySelectorAll("#mini-cart-wrapper, .mini-cart-wrapper"),
      function (el) {
        if (!el.hasAttribute("popover") || typeof el.showPopover !== "function") return;
        var wantManual = !enabled;
        var isManual = el.getAttribute("popover") === "manual";
        if (wantManual === isManual) return;
        try {
          var wasOpen = el.matches(":popover-open");
          if (wasOpen) el.hidePopover();
          el.setAttribute("popover", wantManual ? "manual" : "auto");
          if (wasOpen) el.showPopover();
        } catch (e) {}
      });
  }

  // The scrim is core's own element, shown by core via the .loxa-open class. We only
  // mirror our promotion state onto it — never its visibility, or a stale inline
  // display would outlive us and leave a later core-opened sidebar undimmed.
  function watchSidebarPromotion() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (!panel || panel.__loxaOverlayWatched) return;
    panel.__loxaOverlayWatched = true;
    new MutationObserver(function () {
      var open = panel.classList.contains("loxa-sidebar-open");
      if (open) {
        moveIntroIntoHeader();
        updatePolicyLinks();
        setDrawerLightDismiss(false);
        promoteSidebarToTopLayer();
      } else {
        demoteSidebarFromTopLayer();
        restoreDrawerLightDismissAfterClick();
      }
    }).observe(panel, { attributes: true, attributeFilter: ["class"] });
    if (panel.classList.contains("loxa-sidebar-open")) {
      moveIntroIntoHeader();
      updatePolicyLinks();
      setDrawerLightDismiss(false);
      promoteSidebarToTopLayer();
    }

    // Core re-renders the content on each open, so the heading returns to the body.
    var content = panel.querySelector(".loxa-sidebar-content-root") || panel;
    new MutationObserver(function () {
      moveIntroIntoHeader();
      updatePolicyLinks();
    }).observe(content, { childList: true, subtree: true });

    // The top layer paints in insertion order, so anything that re-shows the drawer
    // puts it above us. The theme does that on its own re-renders, not only through
    // our refreshCart, so listen on the drawer itself and jump back on top.
    watchDrawerReshow();
  }

  function watchDrawerReshow() {
    ["#mini-cart-wrapper", ".mini-cart-wrapper"].forEach(function (sel) {
      [].forEach.call(document.querySelectorAll(sel), function (el) {
        if (el.__loxaReshowWatched) return;
        el.__loxaReshowWatched = true;
        el.addEventListener("toggle", function (e) {
          if (e.newState !== "open") return;
          // After the drawer finishes entering the top layer.
          setTimeout(reassertSidebarOnTop, 0);
        });
      });
    });
  }

  // Mirror a term picked in the sidebar back onto the badge.
  function watchSidebarSelection(Loxa) {
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest("#loxa-shopify-sidebar")) return;
      setTimeout(function () {
        var code = Loxa.selectedInsuranceCode;
        if (!code || code === "__none") {
          if (badge.checked) setBadgeChecked(false);
          return;
        }
        badge.checked = true;
        var box = document.querySelector("[data-loxa-badge-checkbox]");
        if (box) box.checked = true;
        repriceBadgeForCode(Loxa, code);
      }, 150);
    }, true);
  }

  // Re-total the badge at the chosen term, using each line's own plan of that term.
  function repriceBadgeForCode(Loxa, code) {
    if (!badge.plans || !badge.plans.length) return;
    var term = null;
    badge.plans[0].quote.insurances.forEach(function (p) {
      if (p.code === code) term = termOf(p);
    });
    if (!term) return;
    var total = 0;
    badge.plans.forEach(function (entry) {
      var match = null;
      entry.quote.insurances.forEach(function (p) {
        if (termOf(p) === term && premiumOf(p) > 0) match = p;
      });
      if (match) entry.plan = match;
      total += premiumOf(entry.plan) * (entry.line.quantity || 1);
    });
    badge.total = total;
    badge.term = term;
    var anchor = badgeAnchor();
    if (!anchor) return;
    anchor.querySelector("[data-loxa-badge-label]").textContent = "Add " + term + " Year Accidental Damage & Stains Protection";
    anchor.querySelector("[data-loxa-badge-price]").textContent = money(total);
  }

  var badgeTimer = null;
  function scheduleBadge(Loxa) {
    clearTimeout(badgeTimer);
    badgeTimer = setTimeout(function () { renderBadge(Loxa); }, 150);
  }

  function watchPdp(Loxa) {
    if (!badgeAnchor()) return;
    renderBadge(Loxa);
    watchSidebarSelection(Loxa);

    // A variant change fires on the form and rewrites the id input's value
    // attribute; both are watched, plus popstate for back/forward.
    var lastVariant = selectedVariantId();
    function onVariantMaybeChanged() {
      var now = selectedVariantId();
      if (!now || now === lastVariant) return;
      lastVariant = now;
      log("variant changed", now);
      scheduleBadge(Loxa);
    }

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener("change", onVariantMaybeChanged);
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        new MutationObserver(onVariantMaybeChanged)
          .observe(idInput, { attributes: true, attributeFilter: ["value"] });
      }
    }
    window.addEventListener("popstate", onVariantMaybeChanged);
    // The theme records the chosen extra on these holders.
    [".selected-mattress-upsell", ".selected-headboard-upsell"].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(function () { scheduleBadge(Loxa); }).observe(el, {
        attributes: true,
        attributeFilter: ["data-variant-id", "data-variant-quantity", "data-price", "class"]
      });
    });
  }

  // ── Overrides on the live app object ───────────────────────────────────────
  function install(Loxa) {
    if (Loxa[APPLIED_FLAG]) return;

    // Covers add paths we do not intercept ourselves; core's random id is the
    // fallback. See linkId for the id shape.
    var originalGenerateLinkId = Loxa._generateLinkId.bind(Loxa);
    Loxa._generateLinkId = function () {
      try {
        var ctx = typeof Loxa.getProductContext === "function" ? Loxa.getProductContext() : null;
        var variantId = ctx && ctx.variantId ? String(ctx.variantId) : null;
        var code = Loxa.selectedInsuranceCode && Loxa.selectedInsuranceCode !== "__none"
          ? String(Loxa.selectedInsuranceCode) : null;
        if (variantId && code) return linkId(variantId, code);
      } catch (e) {}
      return originalGenerateLinkId();
    };

    // Pair by link id only. Core's variant-id fallback removes the wrong cover when
    // the same variant sits in the cart twice.
    Loxa._findAssociatedInsurance = function (productItem) {
      try {
        var props = (productItem && productItem.properties) || {};
        var link = props._loxaLinkId;
        if (!link) return null;
        var items = (Loxa._cachedCartItems) || [];
        for (var i = 0; i < items.length; i++) {
          var p = items[i].properties || {};
          if (p._loxaInsuranceCodeSep && p._loxaLinkId === link) return items[i];
        }
      } catch (e) { notify("_findAssociatedInsurance override threw", e); }
      return null;
    };

    // One cover line per product line, quoted independently and added in a single
    // /cart/add.js alongside the products.
    var originalHandleCartAdd = Loxa._handleCartAddIntercept.bind(Loxa);
    Loxa._handleCartAddIntercept = function (originalFetch, ctx, args) {
      // Core may route cart/update.js and cart/change.js through this hook.
      // Rebuilding those as a PDP add returns cart/add.js JSON (no item_count)
      // and is what painted "undefined" on the basket badge when unticking extras.
      if (!isCartAddRequest(args)) {
        return originalFetch.apply(ctx, args);
      }
      if (hasAtomicHeader(args[1])) {
        return originalFetch.apply(ctx, args);
      }

      var selected = Loxa.getSelectedInsurance();
      var paid = null;
      if (selected && premiumOf(selected) > 0) paid = selected;
      // Core keeps the quote it fetched on page load, so a product that only
      // became insurable after a size change (e.g. a headboard over £100) has
      // no selection there. The badge's own tick and fresh quotes decide.
      if (!paid && badge.checked && badge.plans && badge.plans.length) {
        paid = badge.plans[0].plan;
      }
      if (!paid) return originalHandleCartAdd(originalFetch, ctx, args);

      var lines = insurableLines(Loxa);
      if (!lines.length) return originalHandleCartAdd(originalFetch, ctx, args);

      // Only insure the product the PDP quoted — a drawer or collection upsell of a
      // different item must not inherit this plan.
      // Plain add, not core: core applies the selected plan to whatever is
      // added, so ticking Assembly in the drawer on an insured product page
      // bought a second cover, paired with the Assembly line.
      var added = Loxa._extractVariantIdFromArgs(args);
      if (added && String(added) !== String(lines[0].variantId)) {
        log("add for a different variant — plain add");
        return originalFetch.apply(ctx, args);
      }

      var parsedBody = Loxa._parseRequestBody(args[1] || {});
      if (parsedBody && parsedBody.sections) {
        Loxa._cachedSections = parsedBody.sections;
        if (parsedBody.sections_url) Loxa._cachedSectionsUrl = parsedBody.sections_url;
      }
      Loxa._dispatchHook("loxa:before:cartAdd", { args: args, parsedBody: parsedBody });

      log("insuring lines", lines.length);

      return withShopifyTitles(lines).then(function (titled) {
        return Promise.all(titled.map(function (line) {
          return buildPair(Loxa, line);
        }));
      }).then(function (pairs) {
        var theme = themeAddExtras(args[1] || {});
        var mainVariant = String(lines[0].variantId);
        var items = [];
        pairs.forEach(function (p) {
          var props = {};
          var source = String(p.line.variantId) === mainVariant
            ? theme.parentProps
            : theme.upsellProps[String(p.line.variantId)] || {};
          for (var k in source) {
            if (source.hasOwnProperty(k)) props[k] = source[k];
          }
          if (p.insurance) {
            var pairLinkId = linkId(p.line.variantId, p.planCode, props);
            p.insurance.properties._loxaLinkId = pairLinkId;
            props._loxaLinkId = pairLinkId;
            items.push(p.insurance);
          }
          items.push({
            id: parseInt(p.line.variantId, 10),
            quantity: p.line.quantity,
            properties: props
          });
        });
        theme.extras.forEach(function (extra) { items.push(extra); });
        return addLinesRaw(items).then(function (data) {
          Loxa._dispatchHook("loxa:after:cartAdd", { route: "comfybedss-multi", response: data });
          return new Response(JSON.stringify(data), {
            status: 200, headers: { "Content-Type": "application/json" }
          });
        });
      }).catch(function (e) {
        notify("insured add failed — falling back to plain add", e);
        return originalFetch.apply(ctx, args);
      });
    };

    Loxa[APPLIED_FLAG] = true;
    log("overrides installed");
  }

  // Build one product + cover pair, priced on the line's own quote.
  function buildPair(Loxa, line) {
    return quoteFor(Loxa, line).then(function (quote) {
      var plan = defaultPlan(quote);
      if (!plan) return { line: line, insurance: null };
      return Loxa._resolveInsuranceVariantId(plan).then(function (insVid) {
        if (!insVid) return { line: line, insurance: null };
        // Placeholder id: the add sets the real one once it knows the
        // line's properties (fabric)
        var pairLinkId = linkId(line.variantId, plan.code);
        return {
          line: line,
          planCode: plan.code,
          linkId: pairLinkId,
          insurance: {
            id: parseInt(insVid, 10),
            quantity: line.quantity,
            properties: coverProps(plan, quote, insVid, line.variantId, pairLinkId)
          }
        };
      });
    }).catch(function (e) {
      notify("per-line cover build failed", e, { variantId: line.variantId });
      return { line: line, insurance: null };
    });
  }

  // Property contract read by the orders processor — every key is required.
  function coverProps(plan, quote, insVarId, insuredVariantId, linkId) {
    var term = termOf(plan);
    return {
      _loxaInsuranceCodeSep: plan.code,
      _Premium: money(premiumOf(plan)),
      _loxaSignature: plan.premium_signature || "",
      _loxaInsuranceProductId: String(insVarId),
      _insuredProductId: String(insuredVariantId),
      "Insured Product": quote.productTitle || "",
      _sumInsured: Number(quote.pricePounds || 0).toFixed(2),
      _Category: quote.category || "",
      _loxaTerm: term,
      Cover: term + " Year",
      _loxaLinkId: linkId
    };
  }

  // Theme ATC bundles Assembly/Disposal on the same FormData as the product.
  // This intercept rebuilds /cart/add.js as JSON, so those extras must be copied
  // across or ticking Protection would drop them. Mattress/headboard stay in
  // insurableLines() — only _cb_addon_type rows are passed through here.
  //
  // Nested keys are items[0][properties][_cb_addon_type], not items[0][properties].
  function themeAddExtras(requestInit) {
    var parentProps = {};
    var byIndex = {};
    var body = requestInit && requestInit.body;

    function ensureItem(index) {
      if (!byIndex[index]) byIndex[index] = { properties: {} };
      return byIndex[index];
    }

    function ingestEntries(forEachable) {
      if (!forEachable || typeof forEachable.forEach !== "function") return;
      forEachable.forEach(function (value, key) {
        var parent = /^properties\[([^\]]+)\]$/.exec(key);
        if (parent) {
          parentProps[parent[1]] = String(value);
          return;
        }
        var item = /^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/.exec(key);
        if (!item) return;
        var row = ensureItem(item[1]);
        if (item[3]) {
          row.properties[item[3]] = String(value);
          return;
        }
        if (item[2] === "id") row.id = value;
        else if (item[2] === "quantity") row.quantity = value;
      });
    }

    function ingestObject(obj) {
      if (!obj || typeof obj !== "object") return;
      var props = obj.properties || {};
      for (var k in props) {
        if (props.hasOwnProperty(k) && props[k] != null && props[k] !== "") {
          parentProps[k] = String(props[k]);
        }
      }
      (obj.items || []).forEach(function (it, i) {
        byIndex[i] = {
          id: it && it.id,
          quantity: it && it.quantity,
          properties: (it && it.properties) || {}
        };
      });
    }

    if (typeof FormData !== "undefined" && body instanceof FormData) {
      ingestEntries(body);
    } else if (typeof body === "string") {
      var parsed = null;
      try { parsed = JSON.parse(body); } catch (e) { parsed = null; }
      if (parsed) ingestObject(parsed);
      else ingestEntries(new URLSearchParams(body));
    } else {
      ingestObject(body);
    }

    var extras = extrasFromIndex(byIndex);
    if (!extras.length) extras = extrasFromDom(parentProps);

    // The mattress / headboard rows' own properties (e.g. the headboard's
    // Fabric Colour and image), keyed by variant id, so the rebuilt add keeps them
    var upsellProps = {};
    Object.keys(byIndex).forEach(function (i) {
      var it = byIndex[i];
      var props = it.properties || {};
      if (props._cb_addon_type || !it.id) return;
      upsellProps[String(it.id)] = props;
    });

    return { parentProps: parentProps, extras: extras, upsellProps: upsellProps };
  }

  function extrasFromIndex(byIndex) {
    var extras = [];
    Object.keys(byIndex).sort(function (a, b) {
      return Number(a) - Number(b);
    }).forEach(function (i) {
      var it = byIndex[i];
      var props = it.properties || {};
      if (!props._cb_addon_type) return;
      var id = parseInt(it.id, 10);
      if (!id) return;
      extras.push({
        id: id,
        quantity: parseInt(it.quantity, 10) || 1,
        properties: props
      });
    });
    return extras;
  }

  function extrasFromDom(parentProps) {
    var extras = [];
    var boxes = document.querySelectorAll("[data-optional-extra-checkbox]:checked");
    if (!boxes.length) return extras;

    var form = document.querySelector('form[action*="/cart/add"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var qty = parseInt((qtyInput && qtyInput.value) || "1", 10) || 1;
    var lineId = parentProps._cb_line_id;
    if (!lineId) {
      lineId = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "cb-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      parentProps._cb_line_id = lineId;
    }

    var titleEl = document.querySelector(".product__block--product_title h1");
    var parentTitle = titleEl ? titleEl.textContent.trim() : "";

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var id = parseInt(box.getAttribute("data-variant-id"), 10);
      var addonType = box.getAttribute("data-addon-type");
      if (!id || !addonType) continue;
      var props = {
        _cb_parent_line_id: lineId,
        _cb_addon_type: addonType
      };
      if (parentTitle) props._For = parentTitle;
      extras.push({ id: id, quantity: qty, properties: props });
    }
    return extras;
  }

  function requestUrl(args) {
    var a = args && args[0];
    if (typeof a === "string") return a;
    if (a && typeof a.url === "string") return a.url;
    return "";
  }

  function hasAtomicHeader(requestInit) {
    var headers = (requestInit && requestInit.headers) || {};
    if (headers[ATOMIC_HEADER]) return true;
    if (typeof headers.get === "function" && headers.get(ATOMIC_HEADER)) return true;
    return false;
  }

  function isCartAddRequest(args) {
    if (!/\/cart\/add(\.js)?(\?|$)/.test(requestUrl(args))) return false;
    var body = args && args[1] && args[1].body;
    if (!body) return true;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      if (body.has("updates")) return false;
      var keys = [];
      body.forEach(function (_value, key) { keys.push(key); });
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === "updates" || keys[i].indexOf("updates[") === 0) return false;
      }
      return true;
    }
    var parsed = body;
    if (typeof body === "string") {
      try { parsed = JSON.parse(body); } catch (e) { return true; }
    }
    if (parsed && typeof parsed === "object" && parsed.updates) return false;
    return true;
  }

  function ownHeaders() {
    var h = { "Content-Type": "application/json" };
    h["X-Loxa-Separate-Add"] = "1";
    h[ATOMIC_HEADER] = "1";
    return h;
  }
  function addLinesRaw(items) {
    return fetch(shopRoot() + "/cart/add.js", {
      method: "POST", headers: ownHeaders(), body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/add " + r.status);
      return r.json();
    });
  }
  function changeLineRaw(key, quantity, props) {
    var body = { id: key, quantity: quantity };
    if (props) body.properties = props;
    return fetch(shopRoot() + "/cart/change.js", {
      method: "POST", headers: ownHeaders(), body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/change " + r.status);
      return r.json();
    });
  }

  // /cart/change.js replaces a line's properties wholesale, so re-read and merge.
  // Sending only our own key would wipe the theme's (Fabric Colour, …).
  // `knownCart` skips the re-read when the caller already holds a current cart:
  // a line's key changes with its properties, so a key match is up to date.
  function mergeLineProps(key, changes, knownCart) {
    var source = knownCart && Array.isArray(knownCart.items) ? Promise.resolve(knownCart) : readCart();
    return source.then(function (cart) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) throw new Error("line not found: " + key);
      var props = {};
      var existing = item.properties || {};
      for (var k in existing) {
        if (existing.hasOwnProperty(k)) props[k] = existing[k];
      }
      for (var c in changes) {
        if (!changes.hasOwnProperty(c)) continue;
        // Clearing a property means sending ""; omitting it keeps the old value.
        props[c] = changes[c] === null ? "" : changes[c];
      }
      return changeLineRaw(key, item.quantity, props);
    });
  }

  function stripLinkId(key, knownCart) {
    return mergeLineProps(key, { _loxaLinkId: null }, knownCart);
  }

  // ── Link ids ───────────────────────────────────────────────────────────────
  // Pairing always matches a STORED id, never recomputes one, so an id only has to
  // be stable once written and unique within the cart.
  //
  // Deliberately DETERMINISTIC. Two identical lines (same variant, same fabric) carry
  // the same id, merge into one line and are covered together or not at all — a
  // customer cannot insure one of two identical mattresses. Keeping the id derivable
  // is what makes Shopify merge them: identical properties are required for the merge.
  //
  // The tail is the line's visible properties (Fabric Colour): the same bed in two
  // fabrics stays two lines, and a shared id let one row's untick zero the other
  // row's cover and merged both rows' covers into one.
  function linkId(variantId, planCode, lineProps) {
    var tag = propsTag(lineProps);
    return "lx_" + variantId + "_" + planCode + (tag ? "_" + tag : "");
  }

  // Short hash of a line's visible properties; "" when it has none
  function propsTag(lineProps) {
    var parts = [];
    Object.keys(lineProps || {}).sort().forEach(function (k) {
      var v = lineProps[k];
      if (k.charAt(0) === "_" || v === "" || v == null) return;
      parts.push(k + "=" + v);
    });
    if (!parts.length) return "";
    var text = parts.join("|");
    var hash = 0;
    for (var i = 0; i < text.length; i++) hash = (hash * 31 + text.charCodeAt(i)) | 0;
    return (hash >>> 0).toString(36);
  }

  // Link id for a line being insured from the basket. Another line may already
  // hold that id (its fabric was edited after it was insured, say): a shared id
  // would pair this cover with that line, so take the next free one.
  function linkIdForLine(cart, key, variantId, planCode) {
    var item = null;
    cart.items.forEach(function (it) { if (it.key === key) item = it; });
    var base = linkId(variantId, planCode, item && item.properties);
    var taken = function (id) {
      return cart.items.some(function (it) {
        return it.key !== key && it.properties && it.properties._loxaLinkId === id;
      });
    };
    var id = base;
    for (var n = 2; taken(id); n++) id = base + "_" + n;
    return id;
  }

  // ── Cart rows ──────────────────────────────────────────────────────────────
  // Liquid renders covered rows complete and reserves space for pending ones; JS
  // only fills a pending row's price or collapses it if uninsurable.
  //
  // The title is the LINE title (product + variant) — the engine prices the variant,
  // and an empty product_title makes the endpoint fail.
  function lineFromRow(row) {
    // pricePounds stays null when the attribute is missing rather than becoming 0 —
    // quoteFor rejects on null, which is what we want. A £0 quote is a real premium
    // against a made-up value.
    var pence = parseInt(row.getAttribute("data-loxa-unit-price"), 10);
    return {
      variantId: row.getAttribute("data-loxa-variant-id"),
      quantity: parseInt(row.getAttribute("data-loxa-line-quantity") || "1", 10) || 1,
      pricePounds: isFinite(pence) && pence > 0 ? pence / 100 : null,
      title: cleanTitle(row.getAttribute("data-loxa-title"))
    };
  }

  function fillPendingRows(Loxa) {
    var rows = document.querySelectorAll('[data-loxa-row][data-loxa-state="pending"]:not([data-loxa-resolved])');
    [].forEach.call(rows, function (row) {
      row.setAttribute("data-loxa-resolved", "1");
      var line = lineFromRow(row);
      quoteFor(Loxa, line).then(function (quote) {
        var plan = defaultPlan(quote);
        if (!plan) { row.setAttribute("data-loxa-state", "uninsurable"); return; }
        var priceEl = row.querySelector("[data-loxa-price]");
        var labelEl = row.querySelector("[data-loxa-label]");
        // Premiums are per unit and shown unmultiplied, mirroring what the
        // partial renders on a covered row.
        if (priceEl) priceEl.textContent = money(premiumOf(plan));
        // Only the term is filled in — the label wording lives in the Liquid, and the
        // checkbox already shows whether cover is applied.
        if (labelEl) labelEl.textContent = termOf(plan) + " Year Protection";
        row.setAttribute("data-loxa-state", "offer");
      }).catch(function () {
        // Failed, not uninsurable — leave the row pending so it can retry.
        row.removeAttribute("data-loxa-resolved");
      });
    });
  }

  // The row's ⓘ opens the protection sidebar: what is covered and both terms when
  // uncovered, change the term or remove cover when covered.
  function wireRowDetails(Loxa) {
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(".cart-item__addon-info-btn");
      if (!btn) return;
      var row = btn.closest("[data-loxa-row]");
      if (!row) return;
      var state = row.getAttribute("data-loxa-state");
      if (state !== "covered" && state !== "offer") return;

      e.preventDefault();
      e.stopPropagation();

      var line = lineFromRow(row);
      quoteFor(Loxa, line).then(function (quote) {
        if (!quote) { notify("no quote for cart details", null, { key: line.variantId }); return; }

        // Core derives the CTA wording and which secondary action shows from
        // selectedInsuranceCode, so point it at THIS line's cover before opening.
        var priorCode = Loxa.selectedInsuranceCode;
        Loxa.selectedInsuranceCode = coverCodeForRow(row) || "__none";
        cartSidebarKey = row.getAttribute("data-loxa-line-key");
        cartSidebarPriorCode = priorCode;

        Loxa.openSidebar(quote);
        watchSidebarPromotion();
      }).catch(function (err) {
        notify("cart details failed", err, { variantId: line.variantId });
      });
    }, true);
  }

  // Which cart line opened the sidebar, so an action there applies to that line
  // rather than the PDP product. The prior code restores the PDP's own selection.
  //
  // Held as a line KEY, never a node: the theme's refresh replaces the drawer's
  // innerHTML, so a stored element is detached the moment the cart re-renders and
  // every sidebar button silently stops working.
  var cartSidebarKey = null;
  var cartSidebarPriorCode = null;

  // Resolve the routed row from the live DOM. Returns null once the line is gone.
  // Line keys contain a colon, which needs no escaping inside a quoted attribute
  // selector — only quotes and backslashes do. CSS.escape would escape the colon too
  // and the selector would then match nothing.
  function cartSidebarRow() {
    if (!cartSidebarKey) return null;
    var safe = String(cartSidebarKey).replace(/["\\]/g, "\\$&");
    return document.querySelector('[data-loxa-row][data-loxa-line-key="' + safe + '"]');
  }

  // The plan code of the cover already on this line; null when uncovered.
  // Straight off the row, which Liquid stamps when it resolves the paired cover.
  // The cache this used to read is only filled by readCart(), which does not run when
  // the theme renders the drawer itself — so after an add-to-cart the code came back
  // null and the sidebar offered "Add"/"No thanks" on an already-covered line.
  function coverCodeForRow(row) {
    var code = row.getAttribute("data-loxa-cover-code");
    if (code) return code;
    var coverKey = row.getAttribute("data-loxa-cover-key");
    return (coverKey && coverCodeByKey[coverKey]) || null;
  }

  // Still populated on every cart read, as the fallback for markup that predates
  // data-loxa-cover-code.
  var coverCodeByKey = {};
  function cacheCoverCodes(cart) {
    coverCodeByKey = {};
    (cart.items || []).forEach(function (it) {
      if (isCoverLine(it)) coverCodeByKey[it.key] = it.properties._loxaInsuranceCodeSep;
    });
  }

  function releaseCartSidebar(Loxa) {
    if (cartSidebarPriorCode !== null) {
      Loxa.selectedInsuranceCode = cartSidebarPriorCode;
      cartSidebarPriorCode = null;
    }
    cartSidebarKey = null;
  }

  // Core's sidebar actions are wired to the PDP flow. When a cart row opened the
  // sidebar, take the click first (capture phase) and apply it to that line instead.
  // Routing is cleared on close so a PDP sidebar is never affected.
  // Dismissing our sidebar must never take the mini-cart with it. Both Escape and an
  // outside click otherwise do two things at once: run the app's own close handler,
  // AND light-dismiss the drawer, which is an "auto" popover. Cancelling the event in
  // capture phase stops both, so we close our own panel and leave the drawer exactly
  // as the customer had it. Verified: preventDefault on keydown does suppress the
  // browser's light dismiss.
  function wireSidebarDismiss() {
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !sidebarIsOpen()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeOurSidebar();
    }, true);

    document.addEventListener("click", function (e) {
      if (!sidebarIsOpen() || !e.target || !e.target.closest) return;
      // Inside our panel is not a dismiss; the panel's own handlers deal with it.
      if (e.target.closest("#loxa-shopify-sidebar")) return;
      // Nor is the control that just opened it. The ⓘ lives in the drawer, so this
      // same click reaches here a tick after the panel opened and would close it
      // again — leaving it slid open but demoted, i.e. painting under the drawer.
      if (e.target.closest(".loxa-info-btn, [data-loxa-row]")) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeOurSidebar();
    }, true);
  }

  function sidebarIsOpen() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    return !!panel && panel.classList.contains("loxa-sidebar-open");
  }

  // Which term the sidebar is showing as chosen. Core tracks this in a closure and
  // reflects it with the .loxa-selected class on the option, whose code is in
  // data-loxa-code — it never sets the radio's checked property, so reading
  // :checked finds nothing on open. Radio is the fallback for a manual click.
  function pickedPlanCode(sidebar) {
    var opt = sidebar.querySelector(".loxa-sidebar-option.loxa-selected");
    var code = opt && opt.getAttribute("data-loxa-code");
    if (code && code !== "__none") return code;
    var radio = sidebar.querySelector('input[name="loxa-sidebar-insurance"]:checked');
    return radio && radio.value !== "__none" ? radio.value : null;
  }

  function wireCartSidebarActions(Loxa) {
    document.addEventListener("click", function (e) {
      if (!cartSidebarKey || !e.target || !e.target.closest) return;
      var sidebar = e.target.closest("#loxa-shopify-sidebar");
      if (!sidebar) return;

      // Three distinct actions, matching core: the CTA applies the picked term,
      // Remove takes the cover off, No thanks declines and changes nothing.
      var cta = e.target.closest(".loxa-sidebar-cta");
      var remove = e.target.closest(".loxa-sidebar-remove");
      var noThanks = e.target.closest(".loxa-sidebar-no-thanks");
      if (!cta && !remove && !noThanks) return;

      // All three must stop core's own button handler, which would otherwise act on
      // the PDP product rather than this row.
      e.preventDefault();
      e.stopImmediatePropagation();

      // Resolved from the live DOM: the theme's refresh replaces the drawer's rows,
      // so the element that opened the sidebar may no longer exist.
      var row = cartSidebarRow();
      if (!row) {
        notify("routed cart row is gone — ignoring the sidebar action",
          null, { key: cartSidebarKey });
      } else if (remove) {
        applyCartCoverChange(Loxa, row, null);
      } else if (cta) {
        var picked = pickedPlanCode(sidebar);
        // No resolvable selection must NOT fall through to a removal — that silently
        // stripped the cover instead of adding it.
        if (picked) {
          applyCartCoverChange(Loxa, row, picked);
        } else {
          notify("no plan selected in the cart sidebar — ignoring the CTA");
        }
      }
      // noThanks intentionally does nothing but close.
      releaseCartSidebar(Loxa);
      closeOurSidebar();
    }, true);

    // Clear the routing however the sidebar closed.
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (panel) {
      new MutationObserver(function () {
        if (!panel.classList.contains("loxa-sidebar-open")) releaseCartSidebar(Loxa);
      }).observe(panel, { attributes: true, attributeFilter: ["class", "style"] });
    }
  }

  // Swap a line's cover to a different term, or remove it. A line's price cannot be
  // edited in place, so a term change is remove-then-add with the new code.
  function applyCartCoverChange(Loxa, row, planCode) {
    var key = row.getAttribute("data-loxa-line-key");
    var coverKey = row.getAttribute("data-loxa-cover-key");
    row.setAttribute("data-loxa-busy", "1");
    themeCartLoading(true);

    var work = coverKey ? changeLineRaw(coverKey, 0) : Promise.resolve();

    if (planCode) {
      var line = lineFromRow(row);
      work = work.then(function () {
        return quoteFor(Loxa, line).then(function (quote) {
          var plan = null;
          quote.insurances.forEach(function (p) { if (p.code === planCode) plan = p; });
          if (!plan) throw new Error("plan not in quote: " + planCode);
          return Loxa._resolveInsuranceVariantId(plan).then(function (insVid) {
            if (!insVid) throw new Error("no insurance variant");
            return readCart().then(function (cart) {
              var pairLinkId = linkIdForLine(cart, key, line.variantId, plan.code);
              return mergeLineProps(key, { _loxaLinkId: pairLinkId }, cart).then(function () {
                return addLinesRaw([{
                  id: parseInt(insVid, 10),
                  quantity: line.quantity,
                  properties: coverProps(plan, quote, insVid, line.variantId, pairLinkId)
                }]);
              });
            });
          });
        });
      });
    } else {
      work = work.then(function () { return stripLinkId(key); });
    }

    return work
      .then(function () { return refreshCart(); })
      .catch(function (err) {
        row.removeAttribute("data-loxa-busy");
        notify("cart cover change failed", err, { key: key, planCode: planCode });
        // The sidebar has already closed, so re-render to put the row back in step
        // with the cart rather than leaving it showing a change that did not land.
        return refreshCart();
      })
      .then(function () { themeCartLoading(false); });
  }

  // Brings one product line's cover to the state the customer last asked
  // for, judged against the live cart when the write runs, so queued taps
  // land in order. `liveCart` is the cart the theme's write queue hands over
  // (its last write's result), saving a /cart.js read. Resolves with the new
  // cart when the last write returned one, true when it wrote without one,
  // false when nothing needed writing.
  function syncRowCover(Loxa, rowKey, rowLine, wantsCover, liveCart) {
    var source = liveCart && Array.isArray(liveCart.items)
      ? Promise.resolve(liveCart).then(function (cart) { cacheCoverCodes(cart); return cart; })
      : readCart();
    return source.then(function (cart) {
      var parent = null;
      cart.items.forEach(function (it) {
        if (parent || isCoverLine(it) || (it.properties && it.properties._cb_addon_type)) return;
        if (it.key === rowKey) parent = it;
      });
      if (!parent) {
        // A cover write before this one may have re-keyed the line. Skip
        // lines other rows still show: the same bed in another fabric is a
        // separate line of the same variant.
        var claimed = {};
        [].forEach.call(document.querySelectorAll(".cart-item[data-cart-key-id], [data-loxa-line-key]"), function (el) {
          var k = el.getAttribute("data-cart-key-id") || el.getAttribute("data-loxa-line-key");
          if (k && k !== rowKey) claimed[k] = true;
        });
        cart.items.forEach(function (it) {
          if (parent || isCoverLine(it) || (it.properties && it.properties._cb_addon_type)) return;
          if (claimed[it.key]) return;
          if (String(it.variant_id) === String(rowLine.variantId)) parent = it;
        });
      }
      if (!parent) return false;

      var link = parent.properties && parent.properties._loxaLinkId;
      var cover = null;
      if (link) {
        cart.items.forEach(function (it) {
          if (!cover && isCoverLine(it) && it.properties._loxaLinkId === link) cover = it;
        });
      }

      if (!wantsCover) {
        if (cover) {
          // Zero the cover and strip the link id: a dangling id on an uninsured
          // line cannot be paired and would collide with a later insured add.
          // Zeroing the cover leaves the product line's key alone, and the
          // response is the whole cart: strip the id from it without a re-read
          return changeLineRaw(cover.key, 0)
            .then(function (afterCover) { return stripLinkId(parent.key, afterCover); });
        }
        if (link) {
          return stripLinkId(parent.key, cart);
        }
        return false;
      }

      if (cover) return false;

      var line = {
        variantId: rowLine.variantId,
        quantity: parent.quantity,
        pricePounds: rowLine.pricePounds,
        title: rowLine.title
      };
      return quoteFor(Loxa, line).then(function (quote) {
        var plan = defaultPlan(quote);
        if (!plan) throw new Error("no plan for line");
        return Loxa._resolveInsuranceVariantId(plan).then(function (insVid) {
          if (!insVid) throw new Error("no insurance variant");
          var pairLinkId = linkIdForLine(cart, parent.key, line.variantId, plan.code);
          // Cover first, then the product's link id: that last write is a
          // cart/change.js, whose response is the whole cart, so the theme
          // needs no read-back. Adding the cover leaves the product line's key
          // alone, and reconcile only runs on load or a full re-render, never
          // between these two writes.
          return addLinesRaw([{
            id: parseInt(insVid, 10),
            quantity: line.quantity,
            properties: coverProps(plan, quote, insVid, line.variantId, pairLinkId)
          }]).then(function () {
            return mergeLineProps(parent.key, { _loxaLinkId: pairLinkId }, cart);
          });
        });
      });
    });
  }

  function wireRowToggle(Loxa) {
    document.addEventListener("change", function (e) {
      var box = e.target;
      if (!box || !box.hasAttribute || !box.hasAttribute("data-loxa-checkbox")) return;
      var row = box.closest("[data-loxa-row]");
      if (!row) return;

      // Queue behind the theme's other drawer writes rather than locking the
      // cart: every tap counts, and the drawer repaints once at the end. A
      // lock here swallowed Assembly / Remove taps made while a quote loaded.
      var themeQueue = themeCart();
      if (themeQueue && typeof themeQueue.queueCartWrite === "function") {
        // Blocked only while a blocking save runs; Assembly / Remove saves
        // run quietly and this tap queues behind them
        if (themeQueue._addonBlocking !== undefined ? themeQueue._addonBlocking : themeQueue._addonLoading) {
          box.checked = !box.checked;
          return;
        }

        var rowKey = row.getAttribute("data-loxa-line-key");
        var rowLine = lineFromRow(row);
        var wants = !!box.checked;

        if (typeof themeQueue.setAddonLoading === "function") {
          themeQueue.setAddonLoading(true);
        }
        // Protection takes two cart writes: the whole basket shows the loading
        // wheel straight away until both land, and the total moves underneath
        if (typeof themeQueue.showEstimatedLoxaTotal === "function") {
          themeQueue.showEstimatedLoxaTotal(box);
        }
        if (typeof themeQueue.showLoadingOverlay === "function") {
          themeQueue.showLoadingOverlay(true, true);
        }

        themeQueue.queueCartWrite(function (cart) {
          return syncRowCover(Loxa, rowKey, rowLine, wants, cart).then(function (wrote) {
            // A full cart lets the theme skip its own read; {} tells it it
            // wrote without one
            if (wrote && Array.isArray(wrote.items)) return wrote;
            return wrote ? {} : null;
          });
        }, "loxa:" + rowLine.variantId);
        return;
      }

      if (row.getAttribute("data-loxa-busy") === "1") return;

      var key = row.getAttribute("data-loxa-line-key");
      var coverKey = row.getAttribute("data-loxa-cover-key");
      var wantsCover = !!box.checked;
      row.setAttribute("data-loxa-busy", "1");
      themeCartLoading(true);

      var work;
      if (!wantsCover && coverKey) {
        // Zero the cover and strip the link id — a dangling id on an uninsured line
        // cannot be paired and would collide with a later insured add.
        work = changeLineRaw(coverKey, 0).then(function () {
          return stripLinkId(key);
        });
      } else if (wantsCover && !coverKey) {
        var line = lineFromRow(row);
        work = quoteFor(Loxa, line).then(function (quote) {
          var plan = defaultPlan(quote);
          if (!plan) throw new Error("no plan for line");
          return Loxa._resolveInsuranceVariantId(plan).then(function (insVid) {
            if (!insVid) throw new Error("no insurance variant");
            return readCart().then(function (cart) {
              var pairLinkId = linkIdForLine(cart, key, line.variantId, plan.code);
              return mergeLineProps(key, { _loxaLinkId: pairLinkId }, cart).then(function () {
                return addLinesRaw([{
                  id: parseInt(insVid, 10),
                  quantity: line.quantity,
                  properties: coverProps(plan, quote, insVid, line.variantId, pairLinkId)
                }]);
              });
            });
          });
        });
      } else {
        row.removeAttribute("data-loxa-busy");
        themeCartLoading(false);
        return;
      }

      work.then(function () { return refreshCart(); })
        .catch(function (err) {
          row.removeAttribute("data-loxa-busy");
          box.checked = !wantsCover;
          notify("row toggle failed", err, { key: key });
        })
        .then(function () { themeCartLoading(false); });
    }, true);
  }

  // ── Keeping cover in step with its product line ────────────────────────────
  // The theme routes every remove and quantity change through one /cart/update.js
  // post. Fold the paired cover lines into the same updates object so cover follows
  // its product in a single request — no orphan window, no second re-render.
  function installUpdateInterceptor(Loxa) {
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      var urlStr = typeof url === "string" ? url : (url && url.url) || "";
      var method = ((options && options.method) || "GET").toUpperCase();
      if (method !== "POST" || !/\/cart\/update(\.js)?/.test(urlStr)) {
        return originalFetch.apply(this, arguments);
      }
      var headers = (options && options.headers) || {};
      var isOurs = headers[ATOMIC_HEADER] ||
        (typeof headers.get === "function" && headers.get(ATOMIC_HEADER));
      if (isOurs) return originalFetch.apply(this, arguments);

      // No cover in the cart means nothing to fold, so skip the /cart.js read.
      // Judged from the theme's last known cart and the rendered rows.
      var known = themeCart() && themeCart()._cart;
      if (known && Array.isArray(known.items) &&
          !known.items.some(isCoverLine) &&
          !document.querySelector("[data-loxa-cover-key]")) {
        return originalFetch.apply(this, arguments);
      }

      var body = options && options.body;
      var payload = null;
      try { payload = typeof body === "string" ? JSON.parse(body) : null; } catch (e) {}
      if (!payload || !payload.updates) return originalFetch.apply(this, arguments);

      var ctx = this, args = arguments;
      return readCart().then(function (cart) {
        var byKey = {};
        cart.items.forEach(function (i) { byKey[i.key] = i; });

        var added = 0;
        Object.keys(payload.updates).forEach(function (key) {
          var product = byKey[key];
          if (!product || isCoverLine(product)) return;
          var link = product.properties && product.properties._loxaLinkId;
          if (!link) return;
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (!isCoverLine(it) || it.properties._loxaLinkId !== link) continue;
            if (payload.updates.hasOwnProperty(it.key)) break;
            // Cover mirrors its product's quantity; 0 removes it.
            payload.updates[it.key] = payload.updates[key];
            added++;
            break;
          }
        });

        if (!added) return originalFetch.apply(ctx, args);
        log("folded cover lines into the theme's cart update", added);
        var newOptions = {};
        for (var k in options) { if (options.hasOwnProperty(k)) newOptions[k] = options[k]; }
        newOptions.body = JSON.stringify(payload);
        return originalFetch.call(ctx, url, newOptions);
      }).catch(function (e) {
        notify("cart update intercept failed — passing through", e);
        return originalFetch.apply(ctx, args);
      });
    };
    log("cart update interceptor installed");
  }

  function isCoverLine(item) {
    return !!(item && item.properties && item.properties._loxaInsuranceCodeSep);
  }

  function readCart() {
    return fetch(shopRoot() + "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cacheCoverCodes(cart); return cart; });
  }

  // ── Reconcile ──────────────────────────────────────────────────────────────
  // Safety net for states we did not create (back button, no-JS remove). Sweeps
  // cover whose product is gone and mirrors quantity drift. Pairs by link id only,
  // and never back-fills — cover is a paid opt-in.
  var reconciling = false;
  function reconcile(Loxa) {
    if (reconciling) return Promise.resolve();
    reconciling = true;
    return readCart().then(function (cart) {
      var productsByLink = {};
      cart.items.forEach(function (i) {
        if (isCoverLine(i)) return;
        var link = i.properties && i.properties._loxaLinkId;
        if (link) productsByLink[link] = i;
      });

      var coverByLink = {};
      cart.items.forEach(function (i) {
        if (!isCoverLine(i)) return;
        var link = i.properties && i.properties._loxaLinkId;
        if (link) coverByLink[link] = i;
      });

      var updates = {};
      cart.items.forEach(function (it) {
        if (!isCoverLine(it)) return;
        var link = it.properties._loxaLinkId;
        var product = link ? productsByLink[link] : null;
        if (!product) { updates[it.key] = 0; return; }
        if (product.quantity !== it.quantity) updates[it.key] = product.quantity;
      });

      // A product whose cover is gone must not keep its link id, whichever path
      // removed it. One per pass: each /cart/change.js re-keys the line it touches,
      // so the remaining keys go stale after the first write.
      var stray = null;
      cart.items.forEach(function (it) {
        if (stray || isCoverLine(it)) return;
        var link = it.properties && it.properties._loxaLinkId;
        if (link && !coverByLink[link]) stray = it.key;
      });

      if (!Object.keys(updates).length && !stray) return null;
      log("reconcile", { updates: updates, stray: stray || "none" });

      var work = Promise.resolve();
      if (Object.keys(updates).length) {
        work = fetch(shopRoot() + "/cart/update.js", {
          method: "POST", headers: ownHeaders(), body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error("reconcile update " + r.status);
          return r.json();
        });
      }
      if (stray) {
        work = work.then(function () { return stripLinkId(stray); });
      }
      return work.then(function () { refreshCart(); });
    }).catch(function (e) {
      notify("reconcile failed", e);
    }).then(function () { reconciling = false; });
  }

  // Re-render via the theme's own cart, exactly as its handleRemove does: both calls
  // are needed — refreshCart redraws the lines, updateSummary the totals and count.
  function refreshCart() {
    var cart = themeCart();
    if (!cart) return Promise.resolve();
    // Only ask the theme to keep the drawer open if it already was. Passing "open"
    // unconditionally pulled the drawer open after every write, including from the
    // cart page and the PDP where the customer never opened it.
    //
    // null, not undefined: the theme skips its toggle on `cartState !== null`, and
    // toggleCart() with no action TOGGLES — which would close an open drawer.
    var cartState = drawerIsOpen() ? "open" : null;
    return readCart()
      .then(function (data) {
        try { cart.updateSummary(data); } catch (e) { notify("updateSummary failed", e); }
        return cart.refreshCart(cartState);
      })
      .then(function () {
        // The theme's refresh re-shows the drawer popover, which moves it to the top
        // of the top layer — above our sidebar, since paint order there is insertion
        // order and z-index has no effect. Re-promote so we sit back on top.
        reassertSidebarOnTop();
        document.dispatchEvent(new CustomEvent("loxa:cb:cartrendered"));
      })
      .catch(function (e) { notify("cart re-render failed", e); });
  }

  // Put our panel back at the top of the top layer. Drop the attribute rather than
  // calling hidePopover(), which would dismiss the auto drawer along with us.
  function reassertSidebarOnTop() {
    var panel = document.getElementById("loxa-shopify-sidebar");
    if (!panel || !sidebarIsOpen() || !drawerIsOpen()) return;
    if (typeof panel.showPopover !== "function") return;
    try {
      panel.removeAttribute("popover");
      panel.setAttribute("popover", "manual");
      panel.showPopover();
    } catch (e) {}
  }

  // The theme's global cartFunction() factory returns a fully-built Cart with the
  // same methods the theme uses itself.
  //
  // Call it EXACTLY once and cache. Its constructor registers delegated document
  // listeners, so a second instance double-binds every cart write.
  var themeCartInstance = null;
  function themeCart() {
    if (themeCartInstance !== null) return themeCartInstance;
    themeCartInstance = false;
    try {
      if (typeof window.cartFunction === "function") {
        var c = window.cartFunction();
        if (c && typeof c.refreshCart === "function") themeCartInstance = c;
      }
    } catch (e) { notify("could not obtain the theme cart instance", e); }
    if (!themeCartInstance) notify("theme cartFunction() unavailable — cart UI will not refresh");
    return themeCartInstance;
  }

  // Same lock Assembly / Remove use: the drawer overlay until the write lands.
  function themeCartLoading(on) {
    var cart = themeCart();
    if (!cart) return;
    try {
      if (typeof cart.setAddonLoading === "function") {
        cart.setAddonLoading(on);
        return;
      }
      if (on && typeof cart.startLoading === "function") cart.startLoading();
      if (!on && typeof cart.endLoading === "function") cart.endLoading();
    } catch (e) {}
  }

  // Core's cart-banner MutationObserver watches document.body for ANY added
  // node, unfiltered, and re-fetches /cart.js on every hit. This store runs a
  // per-second flash-sale countdown that never stops re-rendering its own
  // spans, so the observer never stops firing either — an unbounded /cart.js
  // loop, worsened by a third-party app (Intelligems) that reacts in turn to
  // the same DOM churn. disableCartVisuals is already on for this store, so
  // _processCartForBanners paints nothing; its only remaining side effects
  // are refreshing _cachedCartItems (also kept current by core's own
  // cart-mutation flows) and re-arming the orphan-insurance sweep, which our
  // own reconcile() already covers — same removal case, plus stray-link
  // cleanup core's sweep doesn't do, and on a tighter cycle (300ms after
  // every render vs core's 5s debounce). Safe to no-op core's call entirely
  // rather than try to out-throttle a MutationObserver we cannot unregister
  // from here.
  function disableCoreCartBannerLoop(Loxa) {
    if (typeof Loxa._processCartForBanners !== "function") return;
    Loxa._processCartForBanners = function () {};
    log("core cart-banner observer neutralised — reconcile() owns orphan cleanup");
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  function ready(Loxa) {
    if (Loxa.cartMode !== "separate") {
      notify('cartMode is not "separate" — snippet inactive', null, { cartMode: Loxa.cartMode });
      return;
    }
    if (Loxa.disableMainFlow) {
      notify("disableMainFlow is on — PDP quote will not run; turn it off in the embed settings");
    }
    if (Loxa.variantIdSource !== "form") {
      notify('variantIdSource is not "form" — the offer will price the previously ' +
        "selected variant. Set it in the embed settings.",
        null, { variantIdSource: Loxa.variantIdSource });
    }
    disableCoreCartBannerLoop(Loxa);
    install(Loxa);
    installUpdateInterceptor(Loxa);
    watchPdp(Loxa);
    fillPendingRows(Loxa);
    wireRowToggle(Loxa);
    wireRowDetails(Loxa);
    wireCartSidebarActions(Loxa);
    // Last: capture-phase handlers on document fire in registration order, so the
    // sidebar's own buttons must be seen before this catch-all dismiss guard.
    wireSidebarDismiss();
    reconcile(Loxa);

    document.addEventListener("loxa:cb:cartrendered", function () { fillPendingRows(Loxa); });

    // Sweep after a cart write settles, not only on load. Does not loop: reconcile
    // re-renders only when it changed something, so the pass it triggers finds
    // nothing and stops.
    document.addEventListener("loxa:cb:cartrendered", function () {
      setTimeout(function () { reconcile(Loxa); }, 300);
    });

    // The theme re-renders cart sections on its own. Resolving is idempotent (keyed
    // off data-loxa-resolved) and debounced so our own writes cannot re-enter it.
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { fillPendingRows(Loxa); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var L = window.LoxaShopify;
      if (L && typeof L._handleCartAddIntercept === "function" &&
          typeof L._generateLinkId === "function" &&
          typeof L._resolveInsuranceVariantId === "function") {
        clearInterval(timer);
        ready(L);
        return;
      }
      if (tries > 100) { clearInterval(timer); notify("LoxaShopify never became ready"); }
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
